import api from './api'

export const getIncidents = timezone => api.get(`/beacon/beacons/?timezone=${timezone}`)
